/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ConfiguredGraph } from '../models/configured-graph';
import { createConfiguredGraph } from '../fn/graphs/create-configured-graph';
import { CreateConfiguredGraph$Params } from '../fn/graphs/create-configured-graph';
import { deleteConfiguredGraph } from '../fn/graphs/delete-configured-graph';
import { DeleteConfiguredGraph$Params } from '../fn/graphs/delete-configured-graph';
import { getConfiguredGraph } from '../fn/graphs/get-configured-graph';
import { GetConfiguredGraph$Params } from '../fn/graphs/get-configured-graph';
import { getsConfiguredGraphs } from '../fn/graphs/gets-configured-graphs';
import { GetsConfiguredGraphs$Params } from '../fn/graphs/gets-configured-graphs';
import { getStationCharts } from '../fn/graphs/get-station-charts';
import { GetStationCharts$Params } from '../fn/graphs/get-station-charts';
import { orderConfiguredGraph } from '../fn/graphs/order-configured-graph';
import { OrderConfiguredGraph$Params } from '../fn/graphs/order-configured-graph';
import { StationChartList } from '../models/station-chart-list';
import { updateConfiguredGraph } from '../fn/graphs/update-configured-graph';
import { UpdateConfiguredGraph$Params } from '../fn/graphs/update-configured-graph';


/**
 * All about graphs
 */
@Injectable({ providedIn: 'root' })
export class GraphsService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStationCharts()` */
  static readonly GetStationChartsPath = '/stations/{uid}/charts';

  /**
   * Get the list of charts for the station.
   *
   * Retrieve the station charts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationCharts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationCharts$Response(params: GetStationCharts$Params, context?: HttpContext): Observable<StrictHttpResponse<StationChartList>> {
    return getStationCharts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the list of charts for the station.
   *
   * Retrieve the station charts
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationCharts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationCharts(params: GetStationCharts$Params, context?: HttpContext): Observable<StationChartList> {
    return this.getStationCharts$Response(params, context).pipe(
      map((r: StrictHttpResponse<StationChartList>): StationChartList => r.body)
    );
  }

  /** Path part for operation `getsConfiguredGraphs()` */
  static readonly GetsConfiguredGraphsPath = '/stations/{uid}/graph/configured';

  /**
   * Get a list of configured graphs.
   *
   * Get a list of configured graphs
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getsConfiguredGraphs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getsConfiguredGraphs$Response(params: GetsConfiguredGraphs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ConfiguredGraph>>> {
    return getsConfiguredGraphs(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a list of configured graphs.
   *
   * Get a list of configured graphs
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getsConfiguredGraphs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getsConfiguredGraphs(params: GetsConfiguredGraphs$Params, context?: HttpContext): Observable<Array<ConfiguredGraph>> {
    return this.getsConfiguredGraphs$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ConfiguredGraph>>): Array<ConfiguredGraph> => r.body)
    );
  }

  /** Path part for operation `createConfiguredGraph()` */
  static readonly CreateConfiguredGraphPath = '/stations/{uid}/graph/configured';

  /**
   * Create a configured graph.
   *
   * Create a configured graph
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createConfiguredGraph()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createConfiguredGraph$Response(params: CreateConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createConfiguredGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a configured graph.
   *
   * Create a configured graph
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createConfiguredGraph$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createConfiguredGraph(params: CreateConfiguredGraph$Params, context?: HttpContext): Observable<void> {
    return this.createConfiguredGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `orderConfiguredGraph()` */
  static readonly OrderConfiguredGraphPath = '/stations/{uid}/graph/configured';

  /**
   * Order the configurated graphs of a Station.
   *
   * Order the configurated graphs of a Station
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderConfiguredGraph()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderConfiguredGraph$Response(params: OrderConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return orderConfiguredGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Order the configurated graphs of a Station.
   *
   * Order the configurated graphs of a Station
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `orderConfiguredGraph$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderConfiguredGraph(params: OrderConfiguredGraph$Params, context?: HttpContext): Observable<void> {
    return this.orderConfiguredGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getConfiguredGraph()` */
  static readonly GetConfiguredGraphPath = '/stations/{uid}/graph/configured/{graphUid}';

  /**
   * Get a configured graph.
   *
   * Get a configured graph
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getConfiguredGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfiguredGraph$Response(params: GetConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredGraph>> {
    return getConfiguredGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a configured graph.
   *
   * Get a configured graph
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getConfiguredGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getConfiguredGraph(params: GetConfiguredGraph$Params, context?: HttpContext): Observable<ConfiguredGraph> {
    return this.getConfiguredGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfiguredGraph>): ConfiguredGraph => r.body)
    );
  }

  /** Path part for operation `updateConfiguredGraph()` */
  static readonly UpdateConfiguredGraphPath = '/stations/{uid}/graph/configured/{graphUid}';

  /**
   * Update a configured graph.
   *
   * Update a configured graph
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateConfiguredGraph()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfiguredGraph$Response(params: UpdateConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateConfiguredGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a configured graph.
   *
   * Update a configured graph
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateConfiguredGraph$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateConfiguredGraph(params: UpdateConfiguredGraph$Params, context?: HttpContext): Observable<void> {
    return this.updateConfiguredGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteConfiguredGraph()` */
  static readonly DeleteConfiguredGraphPath = '/stations/{uid}/graph/configured/{graphUid}';

  /**
   * Delete a configured graph.
   *
   * Delete a configured graph
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteConfiguredGraph()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfiguredGraph$Response(params: DeleteConfiguredGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfiguredGraph>> {
    return deleteConfiguredGraph(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a configured graph.
   *
   * Delete a configured graph
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteConfiguredGraph$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteConfiguredGraph(params: DeleteConfiguredGraph$Params, context?: HttpContext): Observable<ConfiguredGraph> {
    return this.deleteConfiguredGraph$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfiguredGraph>): ConfiguredGraph => r.body)
    );
  }

}
